type InjectScriptInput = {
  script: string;
  element: Element;
  isHeadElement: boolean;
};

export const injectScript = ({ script, element, isHeadElement = false }: InjectScriptInput) => {
  const scriptElement = document.createRange().createContextualFragment(script);
  if (isHeadElement) {
    document.head.appendChild(scriptElement);
  } else {
    element?.replaceChildren(scriptElement);
  }
};
